import { render, staticRenderFns } from "./Layout_UserFollowerView.vue?vue&type=template&id=78631880&scoped=true&"
import script from "./Layout_UserFollowerView.vue?vue&type=script&lang=js&"
export * from "./Layout_UserFollowerView.vue?vue&type=script&lang=js&"
import style0 from "./Layout_UserFollowerView.vue?vue&type=style&index=0&id=78631880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78631880",
  null
  
)

export default component.exports